"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeOrganizationLogoBlocks = exports.ORGANIZATION_LOGO_URL_VARIABLE = void 0;
const waypointBlocks_1 = require("./waypointBlocks");
exports.ORGANIZATION_LOGO_URL_VARIABLE = "{{organization_logo_url}}";
const isOrganizationLogoBlock = (block) => block.type === "Image" && block.data?.props?.url === exports.ORGANIZATION_LOGO_URL_VARIABLE;
const findParentId = (template, blockId) => Object.entries(template).find(([, block]) => (0, waypointBlocks_1.getAllChildrenIds)(block).includes(blockId))?.[0];
const getRenderedColumns = (block) => {
    const props = block.data.props;
    const columns = props?.columns ?? [];
    return columns.slice(0, props?.columnsCount ?? columns.length);
};
const repairContainerAfterLogoRemoval = (template, containerId) => {
    const container = template[containerId];
    if (!container) {
        return;
    }
    if (container.type === "ColumnsContainer") {
        const filledColumns = getRenderedColumns(container).filter((column) => (column.childrenIds ?? []).length > 0);
        if (filledColumns.length === 0) {
            (0, waypointBlocks_1.removeBlocksAndCleanReferences)(template, (0, waypointBlocks_1.getAllBlockIdsToDelete)(containerId, template));
            return;
        }
        if (filledColumns.length > 1) {
            return;
        }
        template[containerId] = {
            type: "Container",
            data: {
                style: container.data.style ?? undefined,
                props: { childrenIds: filledColumns[0].childrenIds ?? [] },
            },
        };
        return;
    }
    if (container.type === "Container" && (0, waypointBlocks_1.getAllChildrenIds)(container).length === 0) {
        (0, waypointBlocks_1.removeBlocksAndCleanReferences)(template, [containerId]);
    }
};
const removeOrganizationLogoBlocks = (template) => {
    const logoIds = Object.entries(template)
        .filter(([, block]) => isOrganizationLogoBlock(block))
        .map(([id]) => id);
    if (logoIds.length === 0) {
        return;
    }
    const parentIds = new Set(logoIds.map((logoId) => findParentId(template, logoId)).filter((id) => Boolean(id)));
    (0, waypointBlocks_1.removeBlocksAndCleanReferences)(template, logoIds);
    for (const parentId of parentIds) {
        repairContainerAfterLogoRemoval(template, parentId);
    }
};
exports.removeOrganizationLogoBlocks = removeOrganizationLogoBlocks;
